module.exports = __webpack_public_path__ + "static/media/card-ads-full-br.600dd87e.png";